import { Component, Input, OnInit } from '@angular/core';
import { MoneyDTO } from '../../../../../../../../system/system-dtos';
import { MoneyService } from '../../../../../../../data-type-widgets/data-type/shared/money/money.service';

@Component({
  selector: 'app-simple-money',
  templateUrl: './simple-money.component.html',
  styleUrls: ['./simple-money.component.scss'],
  standalone: false,
})
export class SimpleMoneyComponent implements OnInit {
  @Input() data: MoneyDTO;

  formatted: string;

  constructor(private moneyService: MoneyService) {}

  ngOnInit(): void {
    this.formatted = this.moneyService.formatMoney(this.data, 'fullValue');
  }
}
